var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',[_vm._v("If we want to create reports, we would put this here! However only people with Access rights would be ablee to do this")])
}
var staticRenderFns = []

export { render, staticRenderFns }